import React, { useState, } from 'react';
import fileDownload from 'js-file-download';
import { TextEncoder, } from 'text-encoding';
import { unparse as unparseCsv, } from 'papaparse';
import { uniq, isFunction } from 'lodash';
import classnames from 'classnames';
import { Button, } from 'reactstrap';

const { keys } = Object;

export default function ExportButton ({ fileName, rows, label = 'エクスポート', beforeExport = _ => _, onFinish = _ => _, ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);

  const onClickExport = async () => {
    setIsExporting(true);
    try {
      await beforeExport();
      const encoder = new TextEncoder('Shift_JIS', { NONSTANDARD_allowLegacyEncoding: true });
      const _rows = isFunction(rows) ? (await rows()) : rows;
      const headers = uniq(_rows.flatMap(_ => keys(_)));
      const fileContent = encoder.encode(unparseCsv({ fields: headers, data: _rows.map(_ => headers.map(h => _[h])) }));
      fileDownload(fileContent, fileName);
      await onFinish(_rows);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button color="secondary" onClick={onClickExport} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas mr-1', { 'fa-spin fa-spinner': isExporting, 'fa-download': !isExporting })} />
      {label}
    </Button>
  );
};
